import React from 'react'
import Home from './Home'
import Number from './Number'
import GamePageCss from '../css/GamePageCss'
import NumberModal from './NumberModal'
import WinningModal from './WinningModal'
import { Helmet } from 'react-helmet';
export default function GamePage() {
    return (
        <>
            <Helmet>
                {/* Page Title */}
                <title>Game Page - Place Bets and View Results | Matka Jantri</title>

                {/* SEO Description */}
                <meta
                    name="description"
                    content="Place your Satta gambling bets and view real-time results. See each number's outcome and total data on MatkaJantri."
                />

                {/* SEO Directives */}
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://app.matkajantri.com/gamepage" />

                {/* Favicon and Icons */}
                <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                {/* Mobile Optimization */}
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                {/* Open Graph for Social Sharing */}
                <meta property="og:title" content="Game Page - Place Bets and View Results | MatkaJantri" />
                <meta
                    property="og:description"
                    content="Place your Satta gambling bets and view real-time results. See each number's outcome and total data on MatkaJantri."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://app.matkajantri.com" />
                <meta property="og:image" content="https://app.matkajantri.com/Logo.png" />
                <meta name="google-site-verification" content="d6d81656210c6db7" />


            </Helmet>


            <GamePageCss>
                <Home />
                <div className="midPart">
                    <Number />
                    {/* <History /> */}
                </div>
                <NumberModal />
                <WinningModal />
            </GamePageCss>
        </>
    )
}
